module.exports = __webpack_public_path__ + "e60ea2e001e569f6dafd982d0d947347.png";